<template>
  <b-card title="İcon">
    <b-row>
      <b-col
          v-if="dataItem.image"
          cols="12"
          md="auto"
          class="text-center"
      >
        <div class="border-1 bordered bg-light p-2 rounded">
          <b-img
              :src="baseURL + '/media/products/' + dataItem.image"
              fluid-grow
          />
        </div>
        <b-button
            class="mt-1"
            variant="danger"
            pill
            size="sm"
            @click="removeLogo"
        >
          <FeatherIcon icon="TrashIcon" /> Görseli Sil
        </b-button>
      </b-col>
      <b-col>
        <b-form-group
            label="Dosya Yükle"
            label-for="logo"
        >
          <b-form-file
              id="logo"
              v-model="upload_logo"
              placeholder="Bir görsel dosyası seçin veya buraya bırakın..."
              drop-placeholder="görsel dosyasını buraya bırakın..."
              browse-text="Dosya Seçin"
              :disabled="!!dataItem.image"
          />
        </b-form-group>
        <b-button
            variant="success"
            :disabled="!upload_logo"
            @click="uploadLogo"
        >
          Dosya Yükle
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BImg, BFormGroup, BFormFile, BButton,
} from 'bootstrap-vue'

export default {
  name: 'LogoCard',
  components: {
    BCard, BRow, BCol, BImg, BFormGroup, BFormFile, BButton,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      upload_logo: null,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productsReynaersItems/dataItem']
    },
  },
  methods: {
    removeLogo() {
      this.$store.dispatch('cropperUploads/removeData', {
        filename: this.dataItem.image,
        component: 'icon',
        params: 'icon',
      })
          .then(response => {
            if (response.status) {
              this.dataItem.image = null
            }
          })
    },
    uploadLogo() {
      this.$store.dispatch('cropperUploads/uploadImage', {
        folder: 'products',
        resize: true,
        width: 293,
        thumb: false,
        webp: false,
        ordering: 1,
        component: 'icon',
        params: 'icon',
        item_id: this.dataItem.id,
        upload_image: this.upload_logo,
        filename: 'logo.png' || 'logo.png',
      })
          .then(response => {
            if (response.status) {
              console.log(response)
              this.dataItem.mediaData = response.data
              this.dataItem.image = response.data.filename
            }
          })
    },
  },
}
</script>
